export const LOGIN_INPUT = 'w-full rounded-md border border-line bg-surface px-3 py-2 text-[13.5px]';
export const LOGIN_PRIMARY =
  'cursor-pointer rounded-md bg-accent px-3 py-2 text-[13px] font-semibold text-white disabled:cursor-not-allowed disabled:opacity-40';

/** 로그인·비밀번호 설정 화면의 공통 틀 — 셸 밖이라 사이드바 없이 가운데 카드 하나다. */
export function LoginFrame({ title, hint, children }: { title: string; hint: string; children: React.ReactNode }): React.JSX.Element {
  return (
    <div className="grid min-h-screen place-items-center bg-canvas px-4">
      <section className="w-full max-w-[360px] rounded-lg border border-line bg-surface p-6">
        <div className="mb-5 flex items-center gap-2.5">
          <span className="grid size-8 place-items-center rounded-md bg-accent text-xs font-bold text-white">ND</span>
          <span>
            <strong className="block text-[13px]">ND Console</strong>
            <span className="block text-[11px] text-muted">개발팀 내부 어드민</span>
          </span>
        </div>
        <h1 className="text-[15px] font-bold">{title}</h1>
        <p className="mb-4 text-[12px] text-muted">{hint}</p>
        {children}
      </section>
    </div>
  );
}
